const SITE_URL = "https://www.getabg.one";

const ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}#organization`,
  name: "αβΓ✻1",
  alternateName: ["αβΓ", "Alpha Beta Gamma", "abg", "ABG"],
  url: SITE_URL,
  logo: `${SITE_URL}/icon-192.png`,
  description:
    "αβΓ✻1 is an educational options simulator and analytics tool. The brand is written with the Greek letters alpha, beta, and capital Gamma — directly corresponding to the letters a, b, g in the domain getabg.one. It is not a broker, not a fund, and not an investment platform.",
  foundingDate: "2026",
  knowsAbout: [
    "options trading education",
    "options Greeks",
    "risk analysis",
    "strategy simulation",
  ],
};

const WEBSITE = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}#website`,
  url: SITE_URL,
  name: "αβΓ✻1",
  alternateName: ["αβΓ", "Alpha Beta Gamma"],
  description:
    "An educational simulator and analytics tool for options traders.",
  publisher: { "@id": `${SITE_URL}#organization` },
  inLanguage: ["en-US", "zh-CN"],
};

const DISCLAIMER = {
  "@context": "https://schema.org",
  "@type": "Statement",
  about: { "@id": `${SITE_URL}#organization` },
  text: "αβΓ✻1 does not accept deposits, manage funds, or promise returns. It is not affiliated with any cryptocurrency scheme, signal service, or investment program that uses the letters 'abg', 'ABG', or the Greek sequence 'αβΓ'.",
};

export function JsonLd() {
  const payload = [ORGANIZATION, WEBSITE, DISCLAIMER];
  return (
    <script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(payload) }}
      id="abg-jsonld"
      type="application/ld+json"
    />
  );
}
